module.exports = __webpack_public_path__ + "img/ball_2_green.d4fcc52f.png";